import React from 'react';

import {useBeneficiaryCard} from 'presentation/hooks';
import {PlanTypeEnum} from 'presentation/constants';
import {useTheme} from '@mui/material';
import {TagChip} from '../TagChip';

export function PlanTypeChip() {
	const {beneficiaryCardPlanData, tipoPlanoC} = useBeneficiaryCard();
	const {colors} = useTheme();

	return (
		<TagChip
			label={beneficiaryCardPlanData.chipLabel}
			color={beneficiaryCardPlanData.chipColor}
			bgColor={
				tipoPlanoC === PlanTypeEnum.HEALTH ? colors.light.primary['30Percent'] : undefined
			}
			sx={{alignSelf: 'flex-start', mt: 1}}
		/>
	);
}
